import { useState, useEffect } from 'react';
import ShopNav from '../../../../components/shopNav/ShopNav';
import Footer from '../../../../components/footer/footer';
import NavCategorias from '../../../../components/navbar/NavCategorias';
import ShippingInfoForm from '../../../../components/checkout/shippingInfoForm/ShippingInfoForm';
import ShippingMethodSelector from '../../../../components/checkout/shippingMethodSelector/ShippingMethodSelector';
import CartItemsList from '../../../../components/checkout/cartItemsList/CartItemsList';
import OrderSummary from '../../../../components/checkout/orderSummary/OrderSummary';
import CustomerNoteForm from '../../../../components/checkout/customerNoteForm/CustomerNoteForm';
import BoldCheckoutButton from '../../../../components/checkout/bold/BoldCheckoutButton';
import ServiceHighlights from '../../../../components/servicehighlights/ServiceHighlights';
import OrderLimitAlert from '../../../../components/OrderLimitAlert';

import './checkout.css';

const Checkout = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    ciudad: '',
    departamento: '',
    zip: ''
  });

  const [savedData, setSavedData] = useState(null);

  const [isCartValid, setIsCartValid] = useState(false);
  const [isShippingInfoValid, setIsShippingInfoValid] = useState(false);
  const [isShippingMethodValid, setIsShippingMethodValid] = useState(null);
  const [isSummaryValid, setIsSummaryValid] = useState(null);
  const [isCustomerNoteValid, setIsCustomerNoteValid] = useState(false);

  const isCheckoutValid =
    isShippingInfoValid &&
    isShippingMethodValid &&
    isCartValid &&
    isSummaryValid &&
    isCustomerNoteValid;

  // Cascada de habilitación
  const isShippingInfoEnabled = isCartValid;
  const isShippingMethodEnabled = isShippingInfoValid && isShippingInfoEnabled;
  const isSummaryEnabled = isShippingMethodValid && isShippingMethodEnabled;
  const isCustomerNoteEnabled = isSummaryValid && isSummaryEnabled;

  useEffect(() => {
    console.log('Validación carrito:', isCartValid);
    console.log('Validación de  datos envío:', isShippingInfoValid);
    console.log('Validación método de envio:', isShippingMethodValid);
    console.log('Validación resumen:', isSummaryValid);
    console.log('Nota del cliente', isCustomerNoteValid);
    console.log('Checkout válido:', isCheckoutValid);
  }, [
    isShippingInfoValid,
    isShippingMethodValid,
    isCartValid,
    isSummaryValid,
    isCustomerNoteValid
  ]);

  useEffect(() => {
    const preventFormReloadOnEnter = (e) => {
      if (document.body.classList.contains('modal-open') && e.key === 'Enter') {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', preventFormReloadOnEnter);
    return () => document.removeEventListener('keydown', preventFormReloadOnEnter);
  }, []);

  return (
    <main>
      <ShopNav />
      <NavCategorias />
      <ServiceHighlights />
      <br />
      <OrderLimitAlert />

      <div className="container my-5">
        <h1 className="text-center mb-5 display-5 fw-bold">Finaliza tu Compra</h1>

        {/* 🛒 Lista de productos */}
        <section className="mb-5">
          <CartItemsList setIsValid={setIsCartValid} />
        </section>

        {/* 🚚 Dirección */}
        <section className={`mb-5 ${!isShippingInfoEnabled ? 'disabled-step' : ''}`}>
          <ShippingInfoForm
            formData={formData}
            setFormData={setFormData}
            savedData={savedData}
            setSavedData={setSavedData}
            setIsShippingInfoValid={setIsShippingInfoValid}
          />
        </section>

        {/* 🚚 Método de envío */}
        <section className={`mb-5 ${!isShippingMethodEnabled ? 'disabled-step' : ''}`}>
          <ShippingMethodSelector setIsValid={setIsShippingMethodValid} />
        </section>

        {/* 🧾 Resumen de la orden */}
        <section className={`mb-5 ${!isSummaryEnabled ? 'disabled-step' : ''}`}>
          <OrderSummary setIsSummaryValid={setIsSummaryValid} />
        </section>

        {/* ✏️ Nota adicional */}
        <section className={`mb-5 ${!isCustomerNoteEnabled ? 'disabled-step' : ''}`}>
          <CustomerNoteForm setIsValid={setIsCustomerNoteValid} />
        </section>

        {/* 💳 Botón final */}
        <section className="text-center mb-5">
          <div className="btn-bold">
            <BoldCheckoutButton
              isShippingInfoValid={isShippingInfoValid}
              isShippingMethodValid={isShippingMethodValid}
              isCartValid={isCartValid}
              isSummaryValid={isSummaryValid}
              isCustomerNoteValid={isCustomerNoteValid}
            />
          </div>
        </section>
      </div>

      <Footer />
    </main>
  );
};

export default Checkout;
